<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="600"
    v-model="dialog"
  >
    <template v-slot:activator="{ on, attrs }">
      <p v-if="buySell === 'buy' && !limitOrder">
        You are buying from Upstate Coin & Gold. By executing the trade, you
        agree to all
        <a style="color: #2196f3" v-bind="attrs" v-on="on">Terms & Conditions</a
        >.
      </p>
      <p v-if="buySell === 'buy' && limitOrder">
        This is a limit order, not a confirmed trade. If the limit order is
        fulfilled, a sales order will be executed. By placing this limit order,
        you agree to all of the
        <a style="color: #2196f3" v-bind="attrs" v-on="on">Terms & Conditions</a
        >.
      </p>
      <p v-if="buySell === 'sell'">
        You are selling to Upstate Coin & Gold. By executing the trade, you
        agree to all
        <a style="color: #2196f3" v-bind="attrs" v-on="on">Terms & Conditions</a
        >.
      </p>
      
      <p v-if="buySell === 'login'" class="login-terms">
        By clicking on the Log In button, you understand and agree to
        Upstate Coin &amp; Gold's
        <a class="login-terms__link" :href="termsUrl" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
        and
        <a class="login-terms__link" :href="privacyPolicyUrl" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
      </p>
      
      <p v-if="buySell === 'compAppCompliance'" style="color: #666; text-align: left">
				In this Dealer Account Application, Customer is defined as anyone who transacts business with Upstate Coin &amp; Gold.<br><br>
				By executing this Dealer Account Application, you agree to comply with and be bound by the PlatformGold® 
				Terms and Conditions (<b>“Transaction Terms”</b>), the current version of which is 
				<u><a style="color: #2196f3" v-bind="attrs" v-on="on">located here</a></u>,
				which are hereby incorporated into this Dealer Account Application. All transactions entered into with Upstate Coin &amp; Gold are subject to the
				Transaction Terms. By signing below you agree that you have read the Transaction Terms and agree to be bound by the
				Transaction Terms.
				<br><br>
				The Transaction Terms are subject to change by Upstate Coin &amp; Gold without prior written notice at any time, in our sole discretion.
				Any changes to the Transaction Terms will be in effect as of the “Last Revised Date” referenced in the Transaction Terms. You
				agree to review the Transaction Terms prior to entering any transaction with Upstate Coin &amp; Gold so you are aware of any changes,
				as they are binding on you. Your continued use of PlatformGold® or placing any trade with Upstate Coin &amp; Gold after the “Last
				Revised Date” for the Transaction Terms will constitute your acceptance of and agreement to such changes.
				<br><br>
				Upstate Coin &amp; Gold reserves the right to make criminal, credit, anti-money laundering and general background checks about the
				Customer and its principals, agents and representatives. Customer, on its own behalf and on behalf of its principals, agents and
				representatives, and each individual signing this Dealer Account Application, consents to Upstate Coin &amp; Gold conducting
				background checks on the Customer and the Customer’s principals, agents and representatives, including the individuals signing
				this Dealer Account Application, and Customer has obtained consent from each of its principals, agents and representatives for
				such background checks.
      </p>
    </template>
    <template v-slot:default="dialog">
				<v-card>
					<terms-content></terms-content>
					<v-card-actions class="justify-end">
						<v-btn text @click="closeDialog()">Close</v-btn>
					</v-card-actions>
				</v-card>
    </template>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import TermsContent from '@/components/TermsContent'

export default {
  props: ['buySell', 'limitOrder'],
  components: {TermsContent},
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    termsUrl() {
      return `${window.location.origin}/#/terms`
    },
    privacyPolicyUrl() {
      return `${window.location.origin}/#/privacy-policy`
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false
      // Workaround for https://github.com/vuetifyjs/vuetify/issues/5356
      Vue.nextTick().then(function() {
        document.documentElement.classList.add('overflow-y-hidden')
      })
    },
  },
  mounted() {
    window._VMA.$on('SHOW_TERMS', () => {
      this.dialog = true
    })
  },
}
</script>

<style scoped>
.login-terms {
  color: #666;
  text-align: center;
  line-height: 1.5;
  font-size: 0.9rem;
  max-width: 34rem;
  margin: 0 auto;
  padding: 0 1rem;
  text-wrap: pretty;
}

.login-terms__link {
  color: #2196f3;
  white-space: nowrap;
}

@media (max-width: 599px) {
  .login-terms {
    font-size: 0.8rem;
    line-height: 1.45;
    padding: 0 0.75rem;
  }
}
</style>
